/* eslint-disable react-hooks/exhaustive-deps */
import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { DataTable, DataTableFilterMeta, DataTableSelectionSingleChangeEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { classNames } from 'primereact/utils';
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import React from "react";
import { Dialog } from "primereact/dialog";
import { useMsal } from "@azure/msal-react";
import MaintenanceService from "../../service/MaintenanceService";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import ImageComplete from "../../models/Image";
import { Link } from "react-router-dom";
import { FileUpload, FileUploadHandlerEvent, FileUploadSelectEvent, ItemTemplateOptions } from "primereact/fileupload";
import { Tag } from "primereact/tag";
import { Dropdown } from "primereact/dropdown";
import { Image } from 'primereact/image';
import { InputNumber } from "primereact/inputnumber";
interface DropdownItem {
    name: string;
    code: string;
}

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    imageType: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    imageDesc: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    imageUpdUser: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    imageUpdTs: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    }
};

export default function DrawingsView() {
    let empty: ImageComplete = {
        imageId: 0,
        imageType: '',
        imageDesc: '',
        imageData: '',
        imageBkgrd: '',
        imageUpdUser: '',
        imageUpdTs: ''
    };

    const [listValues, setListValues] = useState<ImageComplete[]>([]);
    const [singleValue, setSingleValue] = useState<ImageComplete>(empty);
    const [imageEdit, setImageEdit] = useState<ImageComplete>(empty);
    const [listFilteredData, setListFilteredData] = useState<ImageComplete[]>([]);
    const [loading, setLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const isNew = useRef(false);
    const form = useForm();
    const [editingRows, setEditingRows] = useState({});
    const errors = form.formState.errors;
    const toast = useRef<any>(null);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const { accounts } = useMsal();
    const [updateTrigger, setUpdateTrigger] = useState(0);
    const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [imageType, setImageType] = useState<string>('');
    const dt = useRef<any>(null);
    const fileUploadRef = useRef<FileUpload>(null);

    const imageTypes: DropdownItem[] = useMemo(
        () => [
            { name: 'Back', code: 'BCK' },
            { name: 'Front', code: 'FRT' }
        ],
        []
    );

    useEffect(() => {
        initFilters();
        MaintenanceService.getDrawings().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        MaintenanceService.getDrawings().then(data => {
            setListValues(data);
            setListFilteredData(data);
            setLoading(false);
        });
    }, [updateTrigger]);

    useEffect(() => {
        isNew.current = false;
        if (imageEdit.imageId === 0) return;
        setImageType(imageEdit.imageType);
        const base64Image = `data:image/*;base64,${imageEdit.imageData}`;
        setSelectedImage(base64Image);
        console.log('Image Edit');
        console.log(imageEdit);
    }, [imageEdit]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const initFilters = () => {
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = null;
        setFilters(defaultFilters);
        setGlobalFilter('');
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <div>
                <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export CSV" onClick={(e) => { exportCSV(); e.stopPropagation(); }} />
            </div>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    const imageIdTemplate = (rowData: ImageComplete) => {
        return rowData.imageId;
    };

    const imageTypeTemplate = (rowData: ImageComplete) => {
        return rowData.imageType;
    };

    const imageDescTemplate = (rowData: ImageComplete) => {
        return rowData.imageDesc;
    };

    const imageUpdUserTemplate = (rowData: ImageComplete) => {
        return rowData.imageUpdUser;
    };

    const imageUpdTsTemplate = (rowData: ImageComplete) => {
        return rowData.imageUpdTs;
    };

    const getErrorMessage = (name: string) => {
        return errors[name] ? <small className="p-error">{(errors[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const save = (value: ImageComplete) => {
        if (isNew.current) {
            MaintenanceService.addDrawing(value).then(() => {
                setUpdateTrigger(prev => prev + 1);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Drawing Created', life: 3000 });
                setSingleValue(empty);
                setSelectedImage(null);
            }).catch(() => {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Drawing', life: 3000 });
            });
        } else {
            MaintenanceService.updateDrawing(value).then(() => {
                setUpdateTrigger(prev => prev + 1);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Drawing Updated', life: 3000 });
                setSingleValue(empty);
                setSelectedImage(null);
            }).catch(() => {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Drawing', life: 3000 });
            });
        }
    }

    const setActiveRowIndexCE = (rowData: DataTableSelectionSingleChangeEvent<ImageComplete[]>) => {
        let selectedIndex = listValues.findIndex(v => v.imageId === (rowData.value as ImageComplete).imageId);
        let _editingRows = { ...editingRows, ...{ [`${listValues[selectedIndex].imageId}`]: true } };
        if (Object.keys(_editingRows).length === 1) {
            setEditingRows(_editingRows);
        }
        MaintenanceService.getDrawingsById((rowData.value as ImageComplete)).then(data => { setImageEdit(data); });
    }

    const onRowEditChange = (e: any) => {
        setEditingRows(e.data);
    }

    const onRowEditComplete = (e: any) => {
        let _listValues = [...listValues];
        let { newData } = e;
        let index = listValues.findIndex(v => v.imageId === newData.imageId);
        _listValues[index] = newData;

        setListValues(_listValues);
    }

    const rowEditorTemplate = (rowData: ImageComplete, props: any) => {
        return (
            <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDelete(rowData)} to={''}></Link>
        );
    }

    const hideDeleteDialog = () => {
        setDeleteDialog(false);
    };

    const confirmDelete = (value: ImageComplete) => {
        setSingleValue(value);
        setDeleteDialog(true);
    }

    const deleteRow = () => {
        MaintenanceService.deleteDrawing(singleValue.imageId).then(() => {
            setUpdateTrigger(prev => prev + 1);
            setDeleteDialog(false);
            setSingleValue(empty);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });
            cancelEdit();
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to remove', life: 3000 });
        });
    };

    const deleteDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteRow} />
        </React.Fragment>
    );

    function arrayBufferToBase64(buffer: ArrayBuffer): string {
        let binary = "";
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }


    const itemTemplate = (inFile: object, props: ItemTemplateOptions) => {
        const file = inFile as File;
        const validFile = ["image/jpeg", "image/png", "image/gif"].includes(file.type);
        if (!validFile) {
            const errorMessage = "Invalid file type: " + file.name;
            toast.current.show({
                severity: "error",
                summary: "Exception",
                detail: errorMessage,
                life: 5000,
            });
            return;
        }
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: "40%" }}>
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
                <Tag
                    value={props.formatSize}
                    severity="warning"
                    className="px-3 py-2"
                />
                <Button
                    type="button"
                    icon="pi pi-times"
                    className="p-button-outlined p-button-rounded p-button-danger ml-auto"
                    onClick={() => onTemplateRemove(props.onRemove)}
                />
            </div>
        );
    };

    const handleFileSelect = (event: FileUploadSelectEvent) => {
        const files = event.files;
        var newFiles: File[] = [];

        for (let i = 0; i < files.length; i++) {
            if (["image/jpeg", "image/png", "image/gif"].includes(files[i].type)) {
                newFiles.push(files[i]);
            }
        }

        setUploadedFiles((uploadedFiles) => [...uploadedFiles, ...newFiles]);

        // Update selectedImage state with the first valid image
        if (newFiles.length > 0) {
            const reader = new FileReader();
            reader.onload = (e: ProgressEvent<FileReader>) => {
                if (e.target?.result) {
                    setSelectedImage(e.target.result as string); // Type cast to string for data URL
                }
            };
            reader.readAsDataURL(newFiles[0]);
        } else {
            setSelectedImage(null); // Clear selected image if no valid files
        }
    };

    const uploadDrawing = async (event: FileUploadHandlerEvent) => {
        if (!imageType) {
            const errorMessage = "No Image Type Selected";
            toast.current.show({
                severity: "error",
                summary: "Exception",
                detail: errorMessage,
                life: 5000,
            });
            return;
        }

        for (const file of event.files) {
            // Check if the file is a PDF by examining its MIME type
            if (!["image/jpeg", "image/png", "image/gif"].includes(file.type)) {
                continue;
            }
            // Create a FileReader instance for each file
            const reader = new FileReader();

            // Create object URL for the file
            const objectURL = URL.createObjectURL(file);

            // Fetch blob data from the object URL
            const blob = await fetch(objectURL).then((r) => r.blob());

            reader.readAsArrayBuffer(blob);
            reader.onloadend = async function () {
                if (imageEdit.imageId > 0) {
                    const base64String = arrayBufferToBase64(reader.result as ArrayBuffer);
                    let _image = { ...imageEdit };
                    _image.imageDesc = file.name;
                    _image.imageType = imageType;
                    _image.imageData = base64String;

                    if (accounts[0]) {
                        _image.imageUpdTs = new Date().toISOString();
                        _image.imageUpdUser = accounts[0].username.split('@')[0];
                    }

                    isNew.current = false;
                    console.log('Edit');
                    console.log(_image);
                    await save(_image);
                } else {
                    const base64String = arrayBufferToBase64(reader.result as ArrayBuffer);
                    let _image = { ...singleValue };
                    _image.imageDesc = file.name;
                    _image.imageType = imageType;
                    _image.imageData = base64String;

                    if (accounts[0]) {
                        _image.imageUpdTs = new Date().toISOString();
                        _image.imageUpdUser = accounts[0].username.split('@')[0];
                    }

                    isNew.current = true;
                    console.log('Add');
                    console.log(_image);
                    await save(_image);
                }

                setUploadedFiles([]);
                cancelEdit();
                URL.revokeObjectURL(objectURL);
            };
        }

        event.options.clear();
    };

    const saveChanges = async () => {
        let _image = { ...imageEdit };
        _image.imageType = imageType;

        if (accounts[0]) {
            _image.imageUpdTs = new Date().toISOString();
            _image.imageUpdUser = accounts[0].username.split('@')[0];
        }

        if (uploadedFiles.length > 0) {
            fileUploadRef.current?.upload();
        } else {
            isNew.current = false;
            await save(_image);
        }

        cancelEdit();
    };

    const onTemplateRemove = (callback: Function) => {
        setSelectedImage(null);
        callback();
    };

    const cancelEdit = () => {
        setSelectedImage(null);
        setImageEdit(empty);
        setImageType('');
        setSingleValue(empty);
        form.reset();
        fileUploadRef.current?.clear();
        isNew.current = true;
    };

    const chooseOptions = { icon: 'pi pi-fw pi-file-pdf', iconOnly: false, className: 'p-button-outlined p-button p-button-sm', label: 'Browse' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: false, className: 'p-button-success p-button-outlined p-button p-button-sm', label: 'Upload' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: false, className: 'p-button-danger p-button-outlined p-button p-button-sm', label: 'Cancel' };


    return (
        <>
            <Toast ref={toast} />

            <Panel header={imageEdit.imageId > 0 ? "Edit Drawing" : "Add Drawing"} className={`addPanel mb-2 -ml-2 ${imageEdit.imageId > 0 ? 'editMode' : 'addMode'}`}>
                <div className="formgrid grid">
                    {imageEdit.imageId > 0 && (
                        <div className="field col-2">
                            <Controller
                                name="imageId"
                                control={form.control}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Image ID</label>
                                        <InputNumber id={field.name} name={field.name} useGrouping={false} disabled value={imageEdit.imageId} className={classNames({ 'p-invalid border-left-10': fieldState.error })} />
                                    </>
                                )}
                            />
                        </div>
                    )}
                    {imageEdit.imageId > 0 && (
                        <div className="field col-2">
                            <Controller
                                name="imageDesc"
                                control={form.control}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Image Name</label>
                                        <InputText id={field.name} name={field.name} value={imageEdit.imageDesc} disabled className={classNames({ 'p-invalid border-left-10': fieldState.error })} />
                                    </>
                                )}
                            />
                        </div>
                    )}
                    <div className="field col-2">
                        <Controller
                            name="imageType"
                            control={form.control}
                            defaultValue={imageEdit.imageType}
                            rules={{
                                required: 'Image Type is required.'
                            }}
                            render={({ field, fieldState }) => (
                                <>
                                    <label htmlFor={field.name} className={classNames('font-bold text-xs', { 'p-error': errors.value })}>Image Type</label>
                                    <Dropdown inputId={field.name} value={fieldState.isDirty ? field.value : imageEdit.imageType} options={imageTypes} optionLabel="name" optionValue="code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                        onChange={(e) => { field.onChange(e.value); setImageType(e.value) }} placeholder="Select..." />
                                    {getErrorMessage('imageType')}
                                </>
                            )}
                        />
                    </div>
                    {imageEdit.imageId > 0 && (
                        <div className="field field-buttons col-4 pt-4">
                            <Button icon="pi pi-save" title="Save" label="Save Changes" rounded text severity="info" type="button" onClick={saveChanges} />
                            <Button icon="pi pi-undo" title="Undo" label="Cancel" rounded text severity="danger" type="button" onClick={cancelEdit} />
                        </div>
                    )}
                </div>
                <div className="grid">
                    <div className="card col-6">
                        <FileUpload
                            ref={fileUploadRef}
                            accept="image/*"
                            customUpload
                            uploadHandler={uploadDrawing}
                            maxFileSize={5000000}
                            emptyTemplate={<p className="m-0">Drag and drop an image to here to upload.</p>}
                            itemTemplate={itemTemplate}
                            onSelect={handleFileSelect}
                            chooseOptions={chooseOptions}
                            uploadOptions={uploadOptions}
                            cancelOptions={cancelOptions}
                            onClear={() => setSelectedImage(null)}
                        />
                    </div>
                    {selectedImage && (
                        <div className="ml-4 col-4">
                            <Image src={selectedImage} alt="Uploaded Image" width="150" height="150" />
                        </div>
                    )}
                </div>

            </Panel>

            <DataTable ref={dt} className="-ml-2" value={listValues} selectionMode="single" onSelectionChange={setActiveRowIndexCE}
                dataKey="imageId" size="small" rowHover={true} loading={loading}
                scrollable scrollHeight="calc(100vh - 23.9rem)"
                paginator rows={25} rowsPerPageOptions={[5, 10, 25]} alwaysShowPaginator={false}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                editingRows={editingRows} editMode="row" onRowEditChange={onRowEditChange} onRowEditComplete={onRowEditComplete}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                filters={filters} header={header} onValueChange={filteredData => setListFilteredData(filteredData)}
                emptyMessage="No drawing records found.">
                <Column field="imageId" header="Image ID" sortable body={imageIdTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="imageType" header="Image Type" sortable body={imageTypeTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                <Column field="imageDesc" header="File Name" sortable body={imageDescTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="imageUpdUser" header="Update User" sortable body={imageUpdUserTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '10%', minWidth: '10rem' }}></Column>
                <Column field="imageUpdTs" header="Update Date" sortable body={imageUpdTsTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '15%', minWidth: '15rem' }}></Column>
                <Column rowEditor body={rowEditorTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>

            <Dialog visible={deleteDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteDialogFooter} onHide={hideDeleteDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {singleValue && (
                        <span>
                            Are you sure you want to delete <b>{singleValue.imageDesc}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </>
    )
}
